

/**
 * 存储枚举
 */
export enum StorageEnum {
  UserInfo = 'userInfo',
  UserToken = 'userToken',
  Settings = 'settings',
  I18N = 'i18nextLng',
}

/**
 * 主题模式
 */
export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

/**
 * 主题布局
 */
export enum ThemeLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
  Mini = 'mini',
}

/**
 * 主题颜色预设
 */
export enum ThemeColorPresets {
  Default = 'default',
  Cyan = 'cyan',
  Purple = 'purple',
  Blue = 'blue',
  Orange = 'orange',
  Red = 'red',
}

/**
 * 核心实体类型
 */
export enum CoreEntityType {
  // codexLibrary
  CodexEntries = "codexEntries",
  CodexFields = "codexFields",
  CodexCategories = "codexCategories",

  // promptLibrary
  Prompts = "prompts",
  PromptDefaults = "promptDefaults",
  PromptPersonas = "promptPersonas",
  PromptPresets = "promptPresets",
  ModelBanks = "modelBanks",
  ModelBankLinks = "modelBankLinks",

  // novelLibrary
  Novels = "novels",
  NovelSeries = "novelSeries",
  NovelScenes = "novelScenes",
  NovelActs = "novelActs",
  NovelChapters = "novelChapters",

  // chatLibrary
  ChatThreads = "chatThreads",
  ChatMessages = "chatMessages",

  Snippets = "snippets",
}

/**
 * 提示词类型
 */
export enum PromptType {
  Other = "other",
  Component = "component",
  SceneCharacterDetection = "sceneCharacterDetection",
  SceneSummarization = "sceneSummarization",
  SceneBeatCompletion = "sceneBeatCompletion",
  ManuscriptCompletion = "manuscriptCompletion",
  ManuscriptReplacement = "manuscriptReplacement",
  CodexCreation = "CodexCreation",
  WorkshopChat = "workshopChat",
}

export enum LocalEnum {
  en_US = 'en_US',
  zh_CN = 'zh_CN',
}

export enum MultiTabOperation {
  FULLSCREEN = 'fullscreen',
  REFRESH = 'refresh',
  CLOSE = 'close',
  CLOSEOTHERS = 'closeOthers',
  CLOSEALL = 'closeAll',
  CLOSELEFT = 'closeLeft',
  CLOSERIGHT = 'closeRight',
}

export enum PermissionType {
  CATALOGUE,
  MENU,
  BUTTON,
}
